import SimpleTable from './container/index';

export default SimpleTable;



// WEBPACK FOOTER //
// ./src/components/page/SimpleTable/index.js